<app-avatar *ngIf="hasAvatar"
            class="avatar"
            [imageSrc]="record?.avatar">
</app-avatar>
<div class="content">
  <ng-container *ngFor="let tuple of record.tuples">
    <p class="record">
      <span class="label"> {{tuple.label}}</span>  <span class="value" [innerHtml]="tuple.value | translate"></span>
    </p>
  </ng-container>
</div>
<div class="actions">
  <ng-container *ngFor="let action of record.actions">
    <button mat-icon-button
            class="action-button"
            (click)="onAction(action.action)">
      <mat-icon *ngIf="action.svgIcon; else simpleIcon"
                [svgIcon]="shouldHighlightRow(record) ? action.highlightSvgIcon : action.svgIcon">
      </mat-icon>
      <ng-template #simpleIcon>
        <mat-icon class="action-icon">{{action.icon}}</mat-icon>
      </ng-template>
    </button>
  </ng-container>
</div>
